import { css } from "styled-components";

const theme = {
    flexboxgrid: {
        // Defaults
        gridSize: 12, // columns
        gutterWidth: 1, // rem
        outerMargin: 2, // rem
        mediaQuery: 'only screen',
        container: {
            sm: 46, // rem
            md: 61, // rem
            lg: 76  // rem
        },
        breakpoints: {
            xs: 0,  // em
            sm: 48, // em
            md: 64, // em
            lg: 75  // em
        }
    },
    colors: {
        black: '#000000',
        white: '#FFFFFF',
        whiteSmoke: '#FCFCFC',
        grey: '#474747',
        lightGrey: '#E6E6E6',
        mediumGrey: '#CCCCCC',
        darkGrey: '#333333',
        dimGrey: '#999999',
        purple: '#4B254E',
        purpleHover: '#420D47',
        lightCyan: '#E9F6FC',
        blue: '#37BCEE',
        lightBlue: '#27AAE1',
        steelBlue: '#86B4C7',
        darkSteelBlue: '#00425B',
        orange: '#FF9900',
        darkOrange: '#FF8800',
        green: '#8AB51E',
        red: '#B51E1E',
        error: '#f44336'
    },
    fonts: {
        comfortaaLight: css`
            font-family: 'Comfortaa', sans-serif;
            font-style: normal;
            font-weight: 300;
        `,
        comfortaaBold: css`
            font-family: 'Comfortaa', sans-serif;
            font-style: normal;
            font-weight: 700;
        `,
        mulishLight: css`
            font-family: 'Mulish', sans-serif;
            font-style: normal;
            font-weight: 300;
        `,
        mulishRegular: css`
            font-family: 'Mulish', sans-serif;
            font-style: normal;
            font-weight: 400;
        `,
        mulishBold: css`
            font-family: 'Mulish', sans-serif;
            font-style: normal;
            font-weight: 700;
        `,
        mulishBlack: css`
            font-family: 'Mulish', sans-serif;
            font-style: normal;
            font-weight: 900;
        `,
        openSansLight: css`
            font-family: 'Open Sans', sans-serif;
            font-style: normal;
            font-weight: 300;
        `,
        openSansBold: css`
            font-family: 'Open Sans', sans-serif;
            font-style: normal;
            font-weight: 700;
        `
    }
};

export default theme;